/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const PREFIX = 'CardHeader';

export const classes = {
  icon: `${PREFIX}-icon`,
};

// Root row: icons + name + badge, horizontal, aligned center
export const CardHeaderRoot = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

// Icon strip — holds provider/analytics icons side by side
export const IconsStrip = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexShrink: 0,

  [`& .${classes.icon}`]: {
    display: 'block',
    width: 22,
    height: 22,
    objectFit: 'contain',
  },
}));

// Project name: sits between icons and badge. Does NOT grow (flex 0) so the badge stays
// pushed left next to the name (Figma node 10284:126188); shrinks + truncates on overflow.
export const ProjectName = styled(Typography)(({theme}) => ({
  flex: '0 1 auto',
  minWidth: 0,
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurface,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

// Mediaplan-type badge
// Figma tokens: bg = --primary/primary-container → #214d72; text = --primary/on-primary-container → #f9fcfe
// border-radius: 9px; padding: 2px 4px; font: 12px / 14px medium
export const MediaplanBadge = styled(Box)(({theme}) => ({
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 9,
  padding: '2px 4px',
  backgroundColor: theme.palette.semantic_dark?.primary.container,
  color: theme.palette.semantic_dark?.primary.onContainer,
  fontSize: 12,
  lineHeight: '14px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
}));
